import React, { useState } from "react";
import { User } from "../types/user";
import { getMyName, getMyVenmo } from "../data/myProfile";
import Modal from "./Modal";
import "./GuestIdentityModal.scss";

interface GuestIdentityModalProps {
  users: User[];
  onSelectExisting: (userId: string) => void;
  onCreateNew: (name: string, venmo: string) => void;
  handleClose: () => void;
}

// First thing a guest sees on a shared link: pick who they are. Either pick a
// mate the owner already listed, or introduce themselves with a name + venmo.
// Picking is device-only — several devices can be the same mate.
const GuestIdentityModal: React.FC<GuestIdentityModalProps> = ({
  users,
  onSelectExisting,
  onCreateNew,
  handleClose,
}) => {
  const [name, setName] = useState(() => getMyName());
  const [venmo, setVenmo] = useState(() => getMyVenmo() || "");


  // everyone but the first mate ("Me" — the owner, who fronted the bill)
  const pickable = users.slice(1);

  const handlePick = (userId: string) => {
    onSelectExisting(userId);
    handleClose();
  };

  const handleJoin = () => {
    if (name.trim() === "") return;
    onCreateNew(name.trim(), venmo.trim());
    handleClose();
  };

  return (
    <Modal
      className="guest-identity-modal"
      title="Who are you?"
      handleClose={handleClose}
    >
      {pickable.length > 0 && (
        <div className="existing-users">
          {pickable.map((user) => (
            <button
              key={user.id}
              className="identity-chip"
              onClick={() => handlePick(user.id)}
            >
              <span className="identity-name">{user.name}</span>
              {user.venmo && (
                <span className="identity-venmo">@{user.venmo}</span>
              )}
            </button>
          ))}
        </div>
      )}

      <div className="divider">
        <span>
          {pickable.length > 0 ? "or add yourself" : "add yourself"}
        </span>
      </div>

      <input
        className="modal-input"
        type="text"
        placeholder="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <input
        className="modal-input"
        type="text"
        placeholder="Venmo (optional)"
        value={venmo}
        onChange={(e) => setVenmo(e.target.value)}
      />
      <button className="modal-button" onClick={handleJoin}>
        Join
      </button>
    </Modal>
  );
};

export default GuestIdentityModal;
